<template>
  <div class="wrapper" :title="title" @click="switchActive">
    <UiBaseIcon width="24px" height="24px" :color="color" icon-name="unplugged" />
  </div>
</template>

<script>
import syncQuery from '@/mixins/syncUrlQuery'
import UiBaseIcon from '@/components/icons/UiBaseIcon.vue'

/** Constant url query key parameter. */
const QUERY_KEY = 'disable'

export default {
  components: { UiBaseIcon },
  mixins: [syncQuery],
  computed: {
    /**
     * Detect state url query paramter `disable`. True if it exists and equals 1.
     */
    shownDisabled() {
      return this.hasQuery(QUERY_KEY) && +this.$query[QUERY_KEY] === 1
    },

    /**
     * Button active colors.
     */
    color() {
      const ACTIVE_COLOR = '#007AFF'
      const DISABLE_COLOR = '#BFBFBF'

      return this.shownDisabled ? ACTIVE_COLOR : DISABLE_COLOR
    },

    /**
     * Button hover titles.
     */
    title() {
      const SHOW_DISABLED = 'Показать отключенные аккаунты'
      const SHOW_ACTIVE = 'Показать активные аккаунты'

      return this.shownDisabled ? SHOW_ACTIVE : SHOW_DISABLED
    },
  },
  methods: {
    /**
     * If shown disabled accounts, then run showActive() method.
     * Else run showDisabled() method.
     *
     * @returns { Void } run show disabled or active method.
     */
    switchActive() {
      if (this.shownDisabled) this.showActive()
      else this.showDisabled()
    },

    /**
     * Remove query paramter `disable` from query URL.
     */
    showActive() {
      this.updateQueryParams({ query: { [QUERY_KEY]: null } })
    },

    /**
     * Set query parameter `disable` = 1 in query URL.
     */
    showDisabled() {
      this.updateQueryParams({ query: { [QUERY_KEY]: 1 } })
    },
  },
}
</script>

<style lang="scss" scoped>
.wrapper {
  cursor: pointer;
}
</style>
